import { render } from "./AnnouncePanel.vue?vue&type=template&id=5d99532a&scoped=true"
import script from "./AnnouncePanel.vue?vue&type=script&lang=js"
export * from "./AnnouncePanel.vue?vue&type=script&lang=js"

import "./AnnouncePanel.vue?vue&type=style&index=0&id=5d99532a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d99532a"]])

export default __exports__